var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"round-tag__tag",class:( _obj = {}, _obj['round-tag__tag_gray'] = (_vm.color === 'gray'), _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }